import { Request } from './request'

export interface ExceptionParams {
  cautionEndTime?: string
  cautionStartTime?: string
  uploadEndTime?: string
  uploadStartTime?: string
  osIds?: string
  pn?: number
  ps?: number
  ruleMainCode?: string
  status?: number
  dataCode?: String
}

export function ExceptionPage(params: ExceptionParams): Request {
  return {
    url: '/api/data/center/caution/list',
    method: 'POST',
    body: params,
  }
}

export function ExceptionDetail(id: number): Request {
  return {
    url: '/api/data/center/caution/info',
    method: 'GET',
    params: {
      cautionId: id,
    },
  }
}
